var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("../../assets/download_bg.jpg"),"alt":""}}),_c('span',{on:{"click":function($event){return _vm.download()}}},[_vm._v("下载特屋兔APP")])])}
var staticRenderFns = []

export { render, staticRenderFns }